export default {
  list: "marketcenter/webchatcollocation/appList", //查询公众号列表
  getAvaliableList: "marketcenter/webchatcollocation/applistAvaliable", //获取租户可用的公众号列表
  getUrl: "marketcenter/webchatcollocation/getUrl", //添加微信号
  add: "marketcenter/webchatcollocation/redirectUrl"
};